var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZenyumWorkingHours(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_905_29108)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18 7.31055L1080.99 -627.189",
    stroke: "#E6EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 10.7744L1082.99 -623.726",
    stroke: "#E6EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14 14.2388L1084.99 -620.261",
    stroke: "#E6EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12 17.7026L1086.99 -616.797",
    stroke: "#E6EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 21.167L1088.99 -613.333",
    stroke: "#E6EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 24.6309L1090.99 -609.869",
    stroke: "#E6EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6 28.0952L1092.99 -606.405",
    stroke: "#E6EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4 31.5591L1094.99 -602.941",
    stroke: "#E6EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2 35.0234L1096.99 -599.477",
    stroke: "#E6EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 38.4873L1098.99 -596.013",
    stroke: "#E6EAED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_905_29108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenyumWorkingHours);
export default __webpack_public_path__ + "static/media/ZenyumWorkingHours.2af17ad23bdcb4e348d59116d39563b2.svg";
export { ForwardRef as ReactComponent };